import { compose } from 'ramda';
import { connect } from 'react-redux';

import queryDuck from '@/features/purchasesStatisticsPage/ducks/query';
import {
  getDefaultMetricsPageUrl,
  getError,
  getItemsIds,
  getItemsTotalCount,
  isLoadingItems,
} from '@/features/purchasesStatisticsPage/selectors';
import { getStatsIds } from '@/features/statisticsPage/selectors';
import withQuerySync from '@/hocs/withQuerySync';

import PurchasesStatistics from './component';

const mapStateToProps = state => ({
  defaultMetricsPageUrl: getDefaultMetricsPageUrl(state),
  error: getError(state),
  itemsIds: getItemsIds(state),
  isLoading: isLoadingItems(state),
  totalCount: getItemsTotalCount(state),
  statsIds: getStatsIds(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
)(PurchasesStatistics);
